import api from '..';

export async function fetchCountries() {
  const response = await api.get('countries');

  return response.data;
}
